import React, {useEffect, useRef} from "react";
import {
    isBotThinkingSelector,
    sendMessageToBot,
    VehicleDetails,
    websiteLocationSelector
} from "../../../chatbotSlice";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {handleLinkInChatClick} from "../../../chatbotUtil";
import {ImageCarousel} from "./ImageCarousel/ImageCarousel";
import {VehicleInfoSection} from "./VehicleInfoSection";
import {OpenDetailsButton} from "./OpenDetailsButton";

interface VehicleCardProps {
    vehicle: VehicleDetails
    reportContentHeight: (headerHeight: number, derivativeHeight: number) => void
    derivativeHeight: number
    headerHeight: number
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
                                                              vehicle,
                                                              reportContentHeight,
                                                              derivativeHeight,
                                                              headerHeight
                                                          }) => {

    const dispatch = useAppDispatch()
    const thinking = useAppSelector(isBotThinkingSelector);
    const websiteLocation = useAppSelector(websiteLocationSelector);
    const headingRef = useRef<HTMLHeadingElement>(null);
    const derivativeRef = useRef<HTMLParagraphElement>(null);

    const handleLinkClick = (e: any) => {
        if (!!vehicle.redirect_url) {
            handleLinkInChatClick(e, vehicle.redirect_url, websiteLocation, false);
        } else {
            if (!thinking) {
                dispatch(sendMessageToBot("Tell me more about this vehicle"))
            }
        }
    }

    useEffect(() => {
        if (headingRef.current && derivativeRef.current) {
            const headingHeight = headingRef.current.clientHeight;
            const derivativeHeight = derivativeRef.current.clientHeight;
            reportContentHeight(headingHeight, derivativeHeight);
        }
    }, [vehicle])

    return <div className="flex flex-col items-center text-base border-2 border-gray rounded-2xl overflow-hidden mx-2 select-none">
        <ImageCarousel images={vehicle.images_url ?? [vehicle.image_url!]} onImageClick={handleLinkClick}/>
        <VehicleInfoSection vehicle={vehicle} headingRef={headingRef} derivativeRef={derivativeRef} headerHeight={headerHeight} derivativeHeight={derivativeHeight}/>
        <OpenDetailsButton vehicle={vehicle} handleLinkClick={handleLinkClick}/>
    </div>
}
